<template>
    <div class="fight-report-history">
        <div v-if="entries.length === 0" class="fight-report-history__empty">{{ $t('journey.fightReportHistory.emptyMessage') }}</div>
        <div v-for="entry in entries" :key="entry.round" class="fight-report-history__entry">
            <span class="fight-report-history__round">{{ entry.round }}</span>
            <span class="fight-report-history__text">{{ entry.text }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FightReportHistory',
    props: {
        roundLog: {type: Array, default: () => []},
    },
    computed: {
        entries() {
            return [...this.roundLog].reverse();
        },
    },
}
</script>

<style scoped>
.fight-report-history {
    /* Vlastni scroll, nezavisi na vysce sdilene s Report tabem. */
    max-height: 280px;
    padding: 0 4px;
    overflow-y: auto;
    /* Nesmi jit vodorovne - kolidovalo by se swipem Report/Historie. */
    overflow-x: hidden;
}
.fight-report-history__empty {
    text-align: center;
    font-size: 13px;
    opacity: 0.6;
    padding: 12px 0;
}
.fight-report-history__entry {
    padding: 4px 0;
    font-size: 14px;
    border-bottom: 1px solid rgba(128, 128, 128, 0.08);
}
.fight-report-history__entry:last-child {
    border-bottom: none;
}
.fight-report-history__round {
    display: inline-block;
    width: 20px;
    opacity: 0.5;
    font-size: 11px;
    vertical-align: top;
}
/* Karta ma podminecne Vuetify `text-no-wrap` (white-space:nowrap !important),
   ktere se DEDI - bez resetu by se historie prestala zalamovat. Scoped
   !important tu ma vyssi specificitu (data-v-atribut), takze spolehlive
   prebije globalni tridu. */
.fight-report-history__text {
    white-space: normal !important;
    overflow-wrap: break-word;
    word-break: break-word;
}
</style>
